import { FiVideo, FiClock, FiUser } from "react-icons/fi";
import { MdCallEnd } from "react-icons/md";
import { useAuth } from "../context/AuthContext";
import "../styles/LiveMeetingPanel.css";

export default function LiveMeetingPanel({ meeting, onEndMeeting, onJoinMeeting }) {
  const { user } = useAuth();

  if (!meeting) return null;

  const {
    videoCallLink,
    solicitorName,
    clientName,
    solicitorPhoto,
    clientPhoto,
    meetingTitle
  } = meeting.extendedProps;

  // 🔥 Decide whom to show based on role
  const isSolicitor = user?.role === "SOLICITOR";

  const displayName = isSolicitor ? clientName : solicitorName;
  const displayPhoto = isSolicitor ? clientPhoto : solicitorPhoto;
  const counterpartRole = isSolicitor ? "Client" : "Solicitor";

  // Handle image error
  const handleImageError = (e) => {
    e.target.style.display = "none";
    const fallbackElement = e.target.nextElementSibling;
    if (fallbackElement && fallbackElement.classList.contains("luxury-participant-fallback")) {
      fallbackElement.style.display = "flex";
    }
  };

  return (
    <div className="luxury-live-meeting-panel">
      {/* Live Indicator Header */}
      <div className="luxury-live-header">
        <div className="luxury-live-indicator">
          <span className="luxury-live-pulse"></span>
          <span className="luxury-live-text">LIVE MEETING</span>
        </div>
      </div>

      {/* Meeting Body */}
      <div className="luxury-live-body">
        {/* Meeting Title */}
        <div className="luxury-meeting-title">
          <h3>{meetingTitle || "Legal Consultation"}</h3>
          <div className="luxury-time-indicator">
            <FiClock size={14} />
            <span>Now in progress</span>
          </div>
        </div>

        {/* Participant Card */}
        <div className="luxury-participant-card">
          <div className="luxury-participant-avatar">
            {displayPhoto ? (
              <img
                src={displayPhoto}
                alt={displayName}
                className="luxury-participant-img"
                onError={handleImageError}
              />
            ) : (
              <div className="luxury-participant-fallback">
                {displayName?.charAt(0)?.toUpperCase() || "U"}
              </div>
            )}
            <div className="luxury-participant-status online"></div>
          </div>

          <div className="luxury-participant-info">
            <h4 className="luxury-participant-name">
              {displayName || "Unknown User"}
            </h4>
            <div className="luxury-participant-role">
              <FiUser size={12} />
              <span>{counterpartRole}</span>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="luxury-live-actions">
          <button
            className="luxury-join-btn"
            onClick={() => {
              // 🔥 Open meeting
              window.open(videoCallLink, "_blank");

              // 🔥 Hide reminder panel after join
              if (typeof onJoinMeeting === "function") {
                onJoinMeeting();
              }
            }}
          >
            <FiVideo className="luxury-btn-icon" />
            <span>Join</span>
          </button>

          <button
            className="luxury-end-btn"
            onClick={onEndMeeting}
            title="End Meeting Session"
          >
            <MdCallEnd className="luxury-btn-icon" />
            <span>End</span>
          </button>
        </div>
      </div>

      {/* Meeting Timer */}
      <div className="luxury-meeting-timer">
        <div className="luxury-timer-display">
          <FiClock size={12} />
          <span>Session Active</span>
        </div>
      </div>
    </div>
  );
}